import React from 'react'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  ChartData,
  ChartOptions
} from 'chart.js'
import { Doughnut } from 'react-chartjs-2'
import { OrderStatus } from '../../types/orders'

// Đăng ký components cho Chart.js
ChartJS.register(ArcElement, Tooltip, Legend)

interface OrderStatusData {
  status: OrderStatus
  count: number
}

interface OrderStatusChartProps {
  title: string
  data: OrderStatusData[]
}

const OrderStatusChart: React.FC<OrderStatusChartProps> = ({ title, data }) => {
  const statusLabels: Record<OrderStatus, string> = {
    pending: 'Chờ xử lý',
    processing: 'Đang xử lý',
    shipped: 'Đã giao hàng',
    delivered: 'Hoàn thành',
    cancelled: 'Đã hủy',
    rejected: 'Từ chối nhận hàng'
  }

  const statusColors: Record<OrderStatus, string> = {
    pending: 'rgba(96, 165, 250, 0.8)', // Blue
    processing: 'rgba(251, 191, 36, 0.8)', // Yellow
    shipped: 'rgba(249, 115, 22, 0.8)', // Orange
    delivered: 'rgba(34, 197, 94, 0.8)', // Green
    cancelled: 'rgba(239, 68, 68, 0.8)', // Red
    rejected: 'rgba(239, 68, 68, 0.8)' // Red (same as cancelled)
  }

  const totalOrders = data.reduce((sum, item) => sum + item.count, 0)

  const chartData: ChartData<'doughnut'> = {
    labels: data.map(item => statusLabels[item.status]),
    datasets: [
      {
        data: data.map(item => item.count),
        backgroundColor: data.map(item => statusColors[item.status]),
        borderColor: data.map(item =>
          statusColors[item.status].replace('0.8', '1')
        ),
        borderWidth: 1,
        hoverOffset: 4
      }
    ]
  }

  const options: ChartOptions<'doughnut'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        align: 'center'
        // labels: {
        //   usePointStyle: true,
        //   // boxWidth: 8,
        //   // padding: 15,
        //   // font: {
        //   //   size: 11,
        //   // },
        // },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.parsed
            const percentage = Math.round((value / totalOrders) * 100)
            return `${context.label}: ${value} (${percentage}%)`
          }
        }
      }
    },
    cutout: '70%',
    layout: {
      padding: {
        left: 10,
        right: 10,
        top: 10,
        bottom: 10
      }
    }
  }

  return (
    <div className='p-5 bg-white rounded-lg shadow'>
      <h2 className='mb-4 text-lg font-semibold'>{title}</h2>
      <div className='flex relative flex-col items-center h-80'>
        <div className='w-full h-full'>
          <Doughnut data={chartData} options={options} />
        </div>
        <div className='absolute top-1/2 left-1/2 text-center transform -translate-x-1/2 -translate-y-1/2'>
          <p className='text-3xl font-bold'>{totalOrders}</p>
          <p className='text-sm text-gray-500'>Tổng số</p>
        </div>
      </div>
    </div>
  )
}

export default OrderStatusChart
